module.exports = __webpack_public_path__ + "7afe565d7e2294d1f2c568b18c285129.png";